import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Form, Input, Button, message } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';

const AdminSignup = () => {
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    if (values.password.length < 6) {
      message.error('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    const result = await signup(values.email, values.password, values.name, 'super_admin');
    if (result.success) {
      message.success('Super admin account created');
      navigate('/super-admin');
    } else {
      message.error(result.message || 'Signup failed');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 24,
    }}>
      <Card
        style={{ width: '100%', maxWidth: 420, boxShadow: '0 10px 40px rgba(0,0,0,0.15)' }}
        title={<span style={{ fontSize: 22, fontWeight: 600 }}>Super Admin Signup</span>}
      >
        <p style={{ color: '#666', marginBottom: 24, fontSize: 14 }}>
          Create the super admin account. If one already exists, signup may be disabled.
        </p>
        <Form form={form} layout="vertical" onFinish={onFinish} size="large">
          <Form.Item name="name" rules={[{ required: true, message: 'Enter name' }]}>
            <Input prefix={<UserOutlined />} placeholder="Name" />
          </Form.Item>
          <Form.Item name="email" rules={[{ required: true, message: 'Enter email' }, { type: 'email' }]}>
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Enter password' }, { min: 6, message: 'Min 6 characters' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} size="large">
              {loading ? 'Creating...' : 'Create Super Admin'}
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', color: '#666' }}>
          Already have an account? <a href="/login">Login</a>
        </div>
      </Card>
    </div>
  );
};

export default AdminSignup;
